// extracted by mini-css-extract-plugin
export default {"container":"description_container__8ppr0","title":"description_title__2Yifx","body":"description_body__3g4hT"};